var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPptIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6531_45115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.01652 1.06055C7.178 1.06591 5.4163 1.79864 4.11626 3.09868C2.81622 4.39872 2.08349 6.16042 2.07812 7.99895L10.8686 9.851L9.01652 1.06055Z",
    fill: "#ED6C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01562 1.06055C10.8542 1.06591 12.6159 1.79864 13.9159 3.09868C15.2159 4.39872 15.9487 6.16042 15.954 7.99895L12.4848 10.357L9.01562 7.99895V1.06055Z",
    fill: "#FF8F6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01653 14.9364C10.8551 14.9311 12.6168 14.1984 13.9168 12.8983C15.2168 11.5983 15.9496 9.83658 15.9549 7.99805H2.07812C2.08349 9.83658 2.81622 11.5983 4.11626 12.8983C5.4163 14.1984 7.178 14.9311 9.01653 14.9364Z",
    fill: "#D35230"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.35525 3.53711H3.71643C2.58354 4.87193 2.00078 6.5877 2.08638 8.33638C2.17197 10.0851 2.9195 11.7357 4.17734 12.9535H8.35525C8.53039 12.9531 8.69824 12.8834 8.82213 12.7596C8.94602 12.6358 9.01586 12.468 9.01638 12.2929V4.19774C9.01586 4.02261 8.94602 3.8548 8.82213 3.73101C8.69824 3.60721 8.53039 3.5375 8.35525 3.53711Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.8595 4.03711H3.33665C2.31506 5.48662 1.89153 7.27415 2.15413 9.02794C2.41674 10.7817 3.34528 12.3668 4.74663 13.4535H7.85999C8.03504 13.453 8.20277 13.3832 8.32655 13.2594C8.45033 13.1357 8.5201 12.9679 8.52063 12.7929V4.69774C8.5201 4.52261 8.45026 4.3548 8.32638 4.23101C8.20249 4.10721 8.03463 4.0375 7.8595 4.03711Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.85943 4.03711H3.33659C2.45663 5.28473 2.01638 6.78948 2.08511 8.31465C2.15383 9.83983 2.72762 11.2989 3.71622 12.4623H7.85993C8.03498 12.4618 8.20271 12.392 8.32649 12.2682C8.45027 12.1445 8.52004 11.9767 8.52056 11.8017V4.69774C8.52004 4.52261 8.4502 4.3548 8.32632 4.23101C8.20243 4.10721 8.03457 4.0375 7.85943 4.03711Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.36383 4.03711H3.33659C2.45663 5.28473 2.01638 6.78948 2.08511 8.31465C2.15383 9.83983 2.72762 11.2989 3.71622 12.4623H7.36433C7.53938 12.4618 7.70711 12.392 7.83089 12.2682C7.95467 12.1445 8.02444 11.9767 8.02496 11.8017V4.69774C8.02444 4.52261 7.9546 4.3548 7.83072 4.23101C7.70683 4.10721 7.53897 4.0375 7.36383 4.03711Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.758291 4.03711H7.36662C7.54183 4.03711 7.70987 4.10671 7.83376 4.2306C7.95765 4.3545 8.02726 4.52253 8.02726 4.69774V11.3061C8.02726 11.4813 7.95765 11.6493 7.83376 11.7732C7.70987 11.8971 7.54183 11.9667 7.36662 11.9667H0.758291C0.58308 11.9667 0.415045 11.8971 0.291152 11.7732C0.167259 11.6493 0.0976563 11.4813 0.0976563 11.3061L0.0976562 4.69774C0.0976562 4.52253 0.167259 4.3545 0.291152 4.2306C0.415045 4.10671 0.58308 4.03711 0.758291 4.03711Z",
    fill: "#C43E1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.05904 5.51834C4.54704 5.48548 5.03088 5.62686 5.42442 5.9173C5.58582 6.06132 5.71236 6.24018 5.79444 6.44032C5.87653 6.64047 5.91201 6.85666 5.89821 7.07254C5.90362 7.35285 5.8217 7.62789 5.66379 7.85955C5.50306 8.11559 5.27175 8.31971 4.9977 8.44734C4.68439 8.59281 4.34195 8.66469 3.99659 8.65747H3.05V10.4743H2.07812V5.51834H4.05904ZM3.0495 7.83923H3.88558C4.15067 7.85873 4.41372 7.78045 4.62501 7.61919C4.70897 7.56518 4.7766 7.48928 4.82062 7.39968C4.86463 7.31008 4.88336 7.21016 4.8748 7.1107C4.8748 6.56257 4.55546 6.2885 3.9168 6.2885H3.0495V7.83923Z",
    fill: "#F9F7F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6531_45115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15.8592,
    fill: "white",
    transform: "translate(0 0.0703125)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPptIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ppt-icon.fb60f7a3.svg";
export { ForwardRef as ReactComponent };